export const timezoneFormatter = (timezone: string) => {
    return timezone.replaceAll('_', ' ')
}
